export default {
  ComplaintSuggestions: [],

  Complaint:{}
};
